'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n'], ['\n  color: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  font-family: ', ';\n  color: ', ';\n  user-select: none;\n  font-size: 12px;\n  margin-bottom: 4px;\n'], ['\n  font-family: ', ';\n  color: ', ';\n  user-select: none;\n  font-size: 12px;\n  margin-bottom: 4px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  align-self: center;\n\n  padding: 8px 6px;\n  margin: 0 2px;\n  border-radius: 6px;\n  cursor: pointer;\n\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.02);\n  }\n'], ['\n  align-self: center;\n\n  padding: 8px 6px;\n  margin: 0 2px;\n  border-radius: 6px;\n  cursor: pointer;\n\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.02);\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _controlGroup = require('./control-group');

var _controlGroup2 = _interopRequireDefault(_controlGroup);

var _controlButton = require('./control-button');

var _controlButton2 = _interopRequireDefault(_controlButton);

var _icons = require('../../assets/icons');

var _miniProgress = require('./mini-progress');

var _miniProgress2 = _interopRequireDefault(_miniProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SlideSwitcher = function (_React$Component) {
  _inherits(SlideSwitcher, _React$Component);

  function SlideSwitcher() {
    _classCallCheck(this, SlideSwitcher);

    return _possibleConstructorReturn(this, (SlideSwitcher.__proto__ || Object.getPrototypeOf(SlideSwitcher)).apply(this, arguments));
  }

  _createClass(SlideSwitcher, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          slide = _props.slide,
          slides = _props.slides,
          showNextSlide = _props.showNextSlide,
          showPrevSlide = _props.showPrevSlide,
          toggleBirdsEye = _props.toggleBirdsEye;


      return _react2.default.createElement(
        _controlGroup2.default,
        { className: className },
        _react2.default.createElement(
          _controlButton2.default,
          {
            onClick: function onClick() {
              return showPrevSlide();
            },
            disabled: slide.isFirst,
            activeIconTransform: 'translateX(-1px)'
          },
          _react2.default.createElement(_icons.LeftArrow, null)
        ),
        _react2.default.createElement(CurrentSlide, {
          onClick: function onClick() {
            return toggleBirdsEye();
          },
          current: slide.index,
          total: slides.length
        }),
        _react2.default.createElement(
          _controlButton2.default,
          {
            onClick: function onClick() {
              return showNextSlide();
            },
            disabled: slide.isLast,
            activeIconTransform: 'translateX(1px)'
          },
          _react2.default.createElement(_icons.RightArrow, null)
        )
      );
    }
  }]);

  return SlideSwitcher;
}(_react2.default.Component);

var CurrentSlide = function CurrentSlide(_ref) {
  var current = _ref.current,
      total = _ref.total,
      onClick = _ref.onClick;
  return _react2.default.createElement(
    NavigationOuter,
    { onClick: onClick },
    _react2.default.createElement(
      Navigation,
      null,
      current + 1,
      _react2.default.createElement(
        TotalLabel,
        null,
        '/',
        total
      )
    ),
    _react2.default.createElement(_miniProgress2.default, { current: current, total: total })
  );
};

var TotalLabel = _styledComponents2.default.span(_templateObject, function (props) {
  return props.theme.mutedTextColor;
});

var Navigation = _styledComponents2.default.div(_templateObject2, function (props) {
  return props.theme.monoFont;
}, function (props) {
  return props.theme.textColor;
});

var NavigationOuter = _styledComponents2.default.div(_templateObject3);

exports.default = SlideSwitcher;